import { isEmpty } from 'lodash';
import ExternalAudienceTargetingType from '../../campaigns/modules/common-campaign-form/config/ExternalAudienceTargetingType';
import TargetingTypes from '../../campaigns/modules/common-campaign-form/config/TargetingTypes';
import { getAudiencesByTargetingType } from '../../campaigns/services/transformers/audienceTransformerUtils';
import { AUDIENCE_TYPE } from '../config';

export const externalAudiencesTransformerToGW = audience => {
    const { domains = {}, keywords = [], type, ...rest } = audience;
    const collection = [];

    const createSRTTargetingValue = (targetingType, valueType, values) => ({
        type: targetingType,
        values: [
            {
                type: valueType,
                values,
            },
        ],
    });

    const createMRTTargetingValue = (targetingType, valueMap) => ({
        type: targetingType,
        values: Object.entries(valueMap).map(([valueType, values]) => ({
            type: valueType,
            values,
        })),
    });

    const getOnlyCategories = selectedValues => {
        return selectedValues.filter(item => {
            const num = Number(item);
            return !isNaN(num);
        });
    };

    const getOnlyDomains = selectedValues => {
        return selectedValues.filter(item => {
            const num = Number(item);
            return isNaN(num);
        });
    };

    if (type === AUDIENCE_TYPE.SEARCH_KEYWORDS) {
        if (!isEmpty(keywords)) {
            collection.push(
                createSRTTargetingValue(TargetingTypes.INCLUDE, ExternalAudienceTargetingType.SRT_KEYWORDS, keywords)
            );
        }
    }

    if (type === AUDIENCE_TYPE.MAIL_DOMAINS) {
        const buildDomainGroup = (domainList, targetingType) => {
            const mailDomains = getOnlyDomains(domainList);
            const categories = getOnlyCategories(domainList);
            const valuesMap = {};

            if (mailDomains.length) {
                valuesMap[ExternalAudienceTargetingType.MRT_DOMAINS] = mailDomains;
            }

            if (categories.length) {
                valuesMap[ExternalAudienceTargetingType.MRT_CATEGORIES] = categories;
            }

            if (Object.keys(valuesMap).length) {
                collection.push(createMRTTargetingValue(targetingType, valuesMap));
            }
        };

        if (domains.include?.length) {
            buildDomainGroup(domains.include, TargetingTypes.INCLUDE);
        }

        if (domains.exclude?.length) {
            buildDomainGroup(domains.exclude, TargetingTypes.EXCLUDE);
        }
    }

    return {
        ...rest,
        ...(collection && collection.length > 0 ? { targetingValues: { collection } } : {}),
        segmentType: type,
        isArchived: rest.status === 'ARCHIVED',
    };
};

export const externalAudiencesTransformerFromGW = audience => {
    const { targetingValues = {}, segmentType } = audience;

    const getTargetingValues = (targetingType, valueType) => {
        const segments = getAudiencesByTargetingType(targetingValues?.collection, targetingType);
        const matchingSegments = segments?.find(v => v.type === valueType);
        return matchingSegments?.values || [];
    };

    let targetingObj = {};
    if (segmentType === AUDIENCE_TYPE.SEARCH_KEYWORDS) {
        targetingObj = {
            keywords: getTargetingValues(TargetingTypes.INCLUDE, ExternalAudienceTargetingType.SRT_KEYWORDS),
        };
    }

    if (segmentType === AUDIENCE_TYPE.MAIL_DOMAINS) {
        targetingObj = {
            domains: {
                include: [
                    ...getTargetingValues(TargetingTypes.INCLUDE, ExternalAudienceTargetingType.MRT_DOMAINS),
                    ...getTargetingValues(TargetingTypes.INCLUDE, ExternalAudienceTargetingType.MRT_CATEGORIES),
                ],
                exclude: [
                    ...getTargetingValues(TargetingTypes.EXCLUDE, ExternalAudienceTargetingType.MRT_DOMAINS),
                    ...getTargetingValues(TargetingTypes.EXCLUDE, ExternalAudienceTargetingType.MRT_CATEGORIES),
                ],
            },
        };
    }

    return {
        ...audience,
        ...targetingObj,
        type: segmentType,
    };
};
